import {FC} from 'react';

import LanguageSelect from '@/components/LanguageSelect/LanguageSelect';

// @ts-ignore
const LoginLanguageSelect: FC = () => <LanguageSelect isDark popoverAlign='end' popoverArrowHeight={12} />;

export default LoginLanguageSelect;
